export const DEFAULT_EXCHANGE_RATE_THRESHOLD = 10
